import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { useTheme } from '@mui/material/styles';
import { JIRA_SYSTEM_CHECK_STATUS } from './jiraIntegrationDetail.constants';

function NRJiraSystemCheckIcon({ status, size = 20, errorIcon = 'cancel', color }) {
  const theme = useTheme();
  const iconSx = {
    width: size,
    height: size,
    flexShrink: 0
  };

  switch (status) {
    case JIRA_SYSTEM_CHECK_STATUS.WARNING:
      return <WarningAmberOutlinedIcon sx={{ ...iconSx, color: color || theme.palette.warning.main }} aria-hidden />;
    case JIRA_SYSTEM_CHECK_STATUS.ERROR: {
      const ErrorIcon = errorIcon === 'exclamation' ? ErrorOutlineOutlinedIcon : CancelOutlinedIcon;
      return <ErrorIcon sx={{ ...iconSx, color: color || theme.palette.error.main }} aria-hidden />;
    }
    case JIRA_SYSTEM_CHECK_STATUS.ACTIVE:
      return <CheckCircleOutlinedIcon sx={{ ...iconSx, color: color || theme.palette.success.main }} aria-hidden />;
    default:
      return <CheckCircleOutlinedIcon sx={{ ...iconSx, color: color || theme.palette.success.main }} aria-hidden />;
  }
}

export default NRJiraSystemCheckIcon;
